<!-- 报到材料 -->
<template>
  <div class="el-checkInMaterials">
    <el-row class="page_content">
        <h1 class="head_title">报到材料</h1>
        <div style="width: 1000px;margin: 0 auto">
            <template v-for="(item,index) in attributeList">
                <div style="margin-bottom: 20px;border: 1px solid rgb(230 230 231);padding: 20px;box-shadow: 1px 2px 4px rgb(230 230 231);border-radius: 10px;">
                  <el-row style="padding-bottom:20px;" :key="index+'attributeList'">
                    <span class="title_l">
                      <span style="color:red;" v-if="item.notNullStatus == 1">*</span>
                      {{item.attributeName}}：
                    </span>
                    <span style="float:left;margin-right:20px;">
                      <el-upload class="avatar-uploader" :action="uploadUrl" :headers="headers" :show-file-list="false"
                        :on-success="(res,file)=>{attributeSuccess(item,res,file)}"
                        disabled
                        :before-upload="item.inputType==5?beforeAvatarUpload:null">
                        <template v-if="item.inputType==5">
                            <img v-if="!$isEmpty(attributeRelationMap[item.attributeId])" :src="$isHttp(attributeRelationMap[item.attributeId])" class="attrList_avatar">
                        </template>
                        <template v-if="item.inputType==6">

                            <img v-if="!$isEmpty(attributeRelationMap[item.attributeId])" :src="filePng" class="attrList_avatar">
                        </template>
                        <i v-if="$isEmpty(attributeRelationMap[item.attributeId])" class="el-icon-plus attrList-uploader-icon" title="点击上传"></i>
                      </el-upload>
                    </span>
                    <span style="float:left;margin-right:20px;">
                        <el-button type="primary" size="small" @click="previewImg(attributeRelationMap[item.attributeId])" v-if="!$isEmpty(attributeRelationMap[item.attributeId]) && item.inputType==5">预览</el-button>
                        <el-button type="primary" size="small" @click="$downLoadFile(attributeRelationMap[item.attributeId],item.attributeName+'附件')" v-if="!$isEmpty(attributeRelationMap[item.attributeId]) && item.inputType==6">下载</el-button>
                    </span>
                  </el-row>
                  <el-row>
                      <span class="title_l">
                        描述：
                      </span>
                      <span style="float:left;margin-right:20px;width: 550px;color: #8c939d;">
                          {{item.attributeValues}}
                      </span>
                  </el-row>
                </div>
            </template>
            <template v-if="attributeList.length <= 0">
                <el-empty description="暂无数据"></el-empty>
            </template>
        </div>
    </el-row>

    <el-dialog
      title=""
      :visible.sync="previewImgShow"
      :show-close="false"
      class="previewImg"
      width="500px"
      :before-close="handleClose">
      <img :src="$isHttp(previewImgUrl)" style="max-width: 100%;" />
      <span slot="footer" class="dialog-footer" style="display: none;">
        <el-button @click="previewImgShow = false">取 消</el-button>
        <el-button type="primary" @click="previewImgShow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getCookieForRoleTag } from "../common/ulit";
import filePng from '@/images/checkInMaterials/fileInfo.png';
export default {
  name: "CheckInMaterials",
  data() {
    return {
      uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
      headers: { token: getCookieForRoleTag(), "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null }, //请求头
      attributeList:[], //报到材料补充
      attributeRelationMap:{}, //报到资料上传值map
      studentConfirmStatus:2, //是否确认资料无误（1是 2否）
      studentNewDataState:2, //状态（1已审核 2未审核 3不通过）
      previewImgShow:false,
      previewImgUrl:"",
      filePng:filePng
    };
  },
  created() {
    this.getStudentNewDataNew();
  },
  methods: {
    getStudentNewDataNew(){ //获取报到材料字段以及确认状态，填写情况
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$store.dispatch("user/getStudentNewData").then((ret) => {
            loading.close();
            if (ret.code == 0) {
                this.attributeList = ret.data.attributeList || [];
                for(let i in this.attributeList){
                    let attributeRelation = this.attributeList[i].attributeRelation;
                    if(!this.$isEmpty(attributeRelation)){
                        this.attributeRelationMap[attributeRelation.attributeIds] = attributeRelation.value;
                    }
                }
                this.studentConfirmStatus = ret.data.studentConfirmStatus;//是否确认资料无误（1是 2否）
                this.studentNewDataState = ret.data.studentNewDataState;//状态（1已审核 2未审核 3不通过）
                this.attributeRelationMap = Object.assign({},this.attributeRelationMap);
            } else {
              this.$message({message: ret.msg,type: 'warning'});
            }
        }).catch(() => {
            loading.close();
        });
    },
    beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt5M = file.size / 1024 / 1024 <= 1;

        if (!isJPG && !isPNG) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
           return false;
        }
        if (!isLt5M) {
            this.$message.error('上传头像图片大小不能超过 1MB!');
             return false;
        }
        return (isJPG || isPNG) && isLt5M;
    },
    attributeSuccess(item,res, file) { //上传成功回调 【报到资料】
      // this.headImg = this.$baseUrl + res.data.url;
        this.attributeRelationMap[item.attributeId] = res.data.url; //写入map
        this.attributeRelationMap = Object.assign({},this.attributeRelationMap);
    },
    previewImg(url){ //预览
        this.previewImgShow = true;
        this.previewImgUrl = url;
    },
    handleClose(){
        this.previewImgShow = false;
    },
  }
};
</script>
<style  lang="less">
@import '../styles/base.less';

.el-checkInMaterials {
  .title_l {
    float: left;
    margin-right: 20px;
    width: 240px;
    text-align: right;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 230px;
    height: 200px;
    line-height: 200px;
    text-align: center;
  }

  .avatar {
    width: 230px;
    height: 200px;
    display: block;
  }

  .slt {
    text-align: center;
    line-height: 30px;
    color: #c5c1c1;
  }

  .title_l {
    float: left;
    margin-right: 20px;
    width: 240px;
    text-align: right;
  }

  .attrList-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 200px;
      height: 100px;
      line-height: 100px;
      text-align: center;
  }
  .attrList_avatar {
       width: 200px;
      height: 100px;
      display: block;
  }
  .previewImg{
      .el-dialog__header{
          display: none;
      }
      .el-dialog__body{
          padding: 0;
      }
      .el-dialog__footer{
          display: none;
      }
  }

  .payDialog {
      .spanTitle{
          display: inline-block;width: 75px;text-align: right;
      }
      .el-col {
          line-height: 3em;

          span {
              &.money {
                  color: red;
              }

              &:nth-child(2) {
                  margin-left: 2em;
              }
          }

          .typeBox {
              span {
                  line-height: 50px;
                  vertical-align: top;
                  display: inline-block;
              }

              img {
                  margin-left: 2em;
                  padding: 10px;
                  border: 1px solid transparent;

                  &.selected {
                      border-color: lightgrey;
                      box-shadow: 0 0 1px grey inset;
                      border-radius: 10px;
                  }

              }
          }

      }

      p.tip {
          margin-bottom: 3em;
      }

      .payInnerDialog {

      }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/CheckInMaterials.vue